import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { combineReducers } from "@reduxjs/toolkit";

import appDataReducer from "./app";
import companyDataReducer from "./company";
import productsDataReducer from "./products";
import orderDataReducer from "./order";
import LogRocket from "logrocket";

// Creating a root reducer to persist data
const reducers = combineReducers({
  app: appDataReducer,
  company: companyDataReducer,
  products: productsDataReducer,
  order: orderDataReducer,
});

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "order/addProductToOrder/rejected",
          "order/removeProductFromOrder/rejected",
          "order/fetchOrder/rejected",
          "company/fetchCompany/rejected",
          "products/fetchProducts/rejected",
        ],
      },
    }).concat(LogRocket.reduxMiddleware()),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
